import * as types from '../../mutation-types'
import TrainerService from '../../../services/trainer'

const actions = {
  get ({ commit, state }, id) {
    return TrainerService.get(id).then((response) => {
      commit(types.GET_TRAINER, {
        trainer: response.data
      })
    })
  },
  setIsTrainer ({ commit, state }, task) {
    commit(types.SET_IS_TRAINER, {
      istrainer: task
    })
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/trainer/actions.js